import React from 'react';
import Navbar from '../Auth/Navbar';
import { Stack, Typography, Box, useMediaQuery, useTheme } from '@mui/material';
import landing from "../assets/landing1.png";
import landing2 from "../assets/landing2.png";
import company1 from "../assets/company1.png";
import company2 from "../assets/company2.png";
import company3 from "../assets/company3.png";

function Landing() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    return (
        <Stack sx={{ minHeight: "100vh", bgcolor: "#fff" }}>
            <Navbar />
            <Stack className='backgroundLanding' alignItems="center" textAlign="center" px={2} py={8}>
                <Typography 
                    variant={isMobile ? 'h5' : 'h3'} 
                    sx={{ color: "#fff", width: { xs: "90%", sm: "60%", md: "40%" }, mb: 2, fontWeight: 'bold', mt: 8 }}
                >
                 <br/>   معًا لدعم المتضررين
                     وإعادة البناء
                </Typography>
                <Typography
    variant="body1"
    sx={{
        color: "#fff",
        width: { xs: "100%", sm: "100%", md: "80%" },
        mb: 2,
        fontWeight: 'normal',
        fontSize: { xs: "2rem", sm: "2.2rem", md: "2.4rem" }, // Adjust font size
        lineHeight: 1.5 // Optional: improves readability with more space between lines
    }}
>
    نربط المتضررين بالمساعدات الفعالة من خلال شبكة من المتبرعين الداعمين لتحقيق التعافي والاستقرار.
</Typography>

                <Stack 
                    direction={{ xs: "column", sm: "row" }} 
                    sx={{ alignItems: 'center', justifyContent: "center", position: 'relative', mt: 4 }}
                    spacing={2}
                >
                    <Box sx={{ maxWidth: "100%", textAlign: "center" }}>
                        <img src={landing} alt="" style={{ width: "100%", maxWidth: "400px" }} />
                    </Box>
                    <Box sx={{ maxWidth: "100%", textAlign: "center" }}>
                        <img src={landing2} alt="" style={{ width: "100%", maxWidth: "400px" }} />
                    </Box>
                </Stack>
            </Stack>
            <Stack alignItems="center" textAlign="center" py={8}>
                <Typography variant='h5' sx={{ fontWeight: "bold", mb: 4 }}>شركاؤنا في التأثير</Typography>
                <Stack 
                    direction={{ xs: "column", sm: "row" }} 
                    alignItems="center" 
                    justifyContent="center" 
                    spacing={2}
                >
                    <Box>
                        <img src={company1} alt="" style={{ width: "100px" }} />
                    </Box>
                    <Box>
                        <img src={company2} alt="" style={{ width: "100px" }} />
                    </Box>
                    <Box>
                        <img src={company3} alt="" style={{ width: "100px" }} />
                    </Box>
                </Stack>
            </Stack>
        </Stack>
    );
}

export default Landing;
